import { usePublicContent } from '../hooks/usePublicContent';
import imgSalvador from '../assets/images/Salvador.png';
import imgSanador from '../assets/images/Sanador.png';
import imgEspiritu from '../assets/images/espiritu.png';
import imgViene from '../assets/images/Viene.png';
import imgBandera from '../assets/images/aimee-bandera.jpg';

export const NosotrosPage = () => {
  const { getText, getImage, getJson } = usePublicContent('NOSOTROS');

  const headerLabel = getText('header', 'label', 'Quiénes somos');
  const headerTitle = getText('header', 'titulo', 'Acerca de Nosotros');
  const headerSubtitle = getText('header', 'subtitulo', 'Conoce nuestra historia, misión y visión como iglesia');

  const historyLabel = getText('historia', 'label', 'Desde 1947');
  const historyTitle = getText('historia', 'titulo', 'Nuestra Historia');
  const historyTexts = getJson<string[]>('historia', 'parrafos', [
    'La Iglesia Cristiana Cuadrangular Central de Apartadó fue fundada con la visión de ser una iglesia que impactara positivamente nuestra comunidad a través del amor de Cristo.',
    'Desde nuestros inicios, hemos sido una congregación comprometida con los cuatro pilares fundamentales del evangelio cuadrangular: Jesucristo como Salvador, Sanador, Bautizador con el Espíritu Santo y Rey que viene.',
    'A lo largo de los años, hemos visto el crecimiento no solo en números, sino en madurez espiritual, impacto comunitario y alcance evangelístico en toda la región de Apartadó.',
  ]);

  const legalLabel = getText('legal', 'label', 'Marco legal');
  const legalTitle = getText('legal', 'titulo', 'Somos Cuadrangulares');
  const legalText1 = getText('legal', 'texto_1', 'La entidad religiosa se denomina IGLESIA CRISTIANA CUADRANGULAR, constituida en el año de 1947 según resolución Nro. 125, expedida por la Gobernación de Santander y con personería jurídica Nro. 125 del 6 de septiembre de 1948, expedida por la Gobernación de Santander y luego con personería jurídica especial Nro. 2002 de diciembre 19 de 1996, otorgada por el Ministerio del Interior, y conformante del Primer Convenio de Derecho Público Interno, aprobado por el decreto 354 de 1998, regulada por el artículo 19 y 94 de la Constitución Política de Colombia, la ley estatutaria 133 de 1994, ley 25 de 1992 y demás normas concordantes, los tratados internacionales sobre derechos humanos, y demás normas jurídicas del bloque de constitucionalidad en materia de libertad e igualdad religiosa, conciencia y culto.');
  const legalText2 = getText('legal', 'texto_2', 'La IGLESIA CRISTIANA CUADRANGULAR utilizará en todos los actos públicos y privados su nombre completo o la sigla ICC, y se constituye como una entidad de naturaleza religiosa, jurídica, exclusiva, y sin ánimo de lucro, enmarcada dentro de las denominadas organizaciones de tendencia, en los términos de ley.');

  const flagLabel = getText('bandera', 'label', 'Símbolo identitario');
  const flagTitle = getText('bandera', 'titulo', 'La bandera cuadrangular');
  const flagDescription = getText('bandera', 'descripcion', 'Cuatro franjas, cuatro verdades. La bandera se izó por primera vez en el Angelus Temple y desde entonces ondea en cada templo cuadrangular del mundo, recordándonos el mensaje completo del Evangelio.');
  const flagColors = getJson<{ nombre: string; color: string; significado: string }[]>('bandera', 'colores', [
    { nombre: 'Rojo', color: 'bg-red-700', significado: 'Sangre de Cristo y perdón de pecados' },
    { nombre: 'Amarillo', color: 'bg-yellow-500', significado: 'Fuego del Espíritu Santo' },
    { nombre: 'Azul', color: 'bg-blue-700', significado: 'Cristo, médico divino y sanidad' },
    { nombre: 'Morado', color: 'bg-purple-800', significado: 'Cristo, Rey venidero y Señor de señores' },
  ]);
  const flagImage = getImage('bandera', 'imagen', imgBandera);

  const purposeLabel = getText('proposito', 'label', 'Nuestro propósito');
  const purposeTitle = getText('proposito', 'titulo', 'Misión y Visión');
  const missionTitle = getText('proposito', 'mision_titulo', 'Nuestra Misión');
  const missionText = getText('proposito', 'mision_texto', 'Formar discípulos de Jesucristo a través de la predicación del evangelio completo, el cuidado pastoral y el servicio a la comunidad, impactando vidas para la gloria de Dios y la extensión de Su reino en la tierra.');
  const visionTitle = getText('proposito', 'vision_titulo', 'Nuestra Visión');
  const visionText = getText('proposito', 'vision_texto', 'Ser una iglesia de referencia en Apartadó y la región, reconocida por su amor, unidad y compromiso con la Gran Comisión, donde cada miembro sea un testimonio vivo del poder transformador de Cristo.');

  const pillarsLabel = getText('pilares', 'label', 'Nuestra doctrina');
  const pillarsTitle = getText('pilares', 'titulo', 'Los Cuatro Pilares');
  const pillarsSubtitle = getText('pilares', 'subtitulo', 'Fundamentos bíblicos que sustentan nuestra fe');
  const pillars = getJson<{ titulo: string; descripcion: string; versiculo: string; imagen?: string }[]>('pilares', 'items', [
    { titulo: 'Jesucristo\nSalvador', descripcion: 'Creemos que Jesús es el único camino de salvación. Por gracia somos salvos mediante la fe en Su sacrificio en la cruz.', versiculo: 'Juan 14:6', imagen: imgSalvador },
    { titulo: 'Jesucristo\nSanador', descripcion: 'Confesamos que Jesús sana hoy. Por Sus llagas fuimos sanados, tanto física como emocionalmente.', versiculo: 'Isaías 53:5', imagen: imgSanador },
    { titulo: 'Jesucristo\nBautizador', descripcion: 'Jesús bautiza con el Espíritu Santo, dando poder para el servicio y manifestando los dones espirituales.', versiculo: 'Hechos 2:4', imagen: imgEspiritu },
    { titulo: 'Jesucristo\nRey que Viene', descripcion: 'Esperamos la segunda venida de Cristo como Rey de reyes y Señor de señores en gloria y majestad.', versiculo: 'Apocalipsis 19:16', imagen: imgViene },
  ]);

  const leadershipLabel = getText('liderazgo', 'label', 'Nuestra familia');
  const leadershipTitle = getText('liderazgo', 'titulo', 'Nuestro Liderazgo');
  const leaders = getJson<{ icono: string; nombre: string; cargo: string; descripcion: string }[]>('liderazgo', 'items', [
    { icono: '👨‍💼', nombre: 'Pastor [Nombre]', cargo: 'Pastor Principal', descripcion: '[Descripción del pastor principal, su llamado ministerial y visión para la iglesia]' },
    { icono: '👩‍💼', nombre: 'Pastora [Nombre]', cargo: 'Pastora', descripcion: '[Descripción de la pastora, su ministerio y áreas de servicio en la iglesia]' },
    { icono: '👥', nombre: 'Equipo Pastoral', cargo: 'Ministerios', descripcion: 'Un equipo comprometido que lidera los diferentes ministerios y áreas de servicio de nuestra iglesia.' },
  ]);

  const valuesLabel = getText('valores', 'label', 'Lo que nos define');
  const valuesTitle = getText('valores', 'titulo', 'Nuestros Valores');
  const values = getJson<{ icono: string; titulo: string; descripcion: string }[]>('valores', 'items', [
    { icono: '❤️', titulo: 'Amor', descripcion: 'El amor de Cristo es el fundamento de todo lo que hacemos' },
    { icono: '🤝', titulo: 'Unidad', descripcion: 'Vivimos en unidad como el cuerpo de Cristo' },
    { icono: '📖', titulo: 'Verdad', descripcion: 'La Palabra de Dios es nuestra guía y autoridad' },
    { icono: '🙏', titulo: 'Servicio', descripcion: 'Servimos con gozo a Dios y a nuestra comunidad' },
    { icono: '✨', titulo: 'Excelencia', descripcion: 'Hacemos todo para la gloria de Dios con excelencia' },
    { icono: '🌟', titulo: 'Esperanza', descripcion: 'Somos portadores de esperanza en Cristo Jesús' },
  ]);

  return (
    <div className="min-h-screen transition-colors duration-300 bg-stone-100">
      
      {/* Header */}
      <section className="relative overflow-hidden pt-32 pb-20 px-6">
        <div className="absolute inset-0 bg-stone-200/30"></div>
        <div className="relative max-w-7xl mx-auto text-center">
          <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium animate-fade-in">{headerLabel}</p>
          <h1 className="text-5xl md:text-6xl font-serif font-bold mb-6 animate-fade-in text-stone-800">
            {headerTitle}
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto mb-6 rounded-full animate-slide-up delay-100"></div>
          <p className="text-xl text-stone-600 animate-slide-up delay-200">
            {headerSubtitle}
          </p>
        </div>
      </section>

      {/* Historia de la Iglesia */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            
            <div className="animate-slide-left">
              <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium">{historyLabel}</p>
              <h2 className="text-4xl font-serif font-bold mb-2 text-stone-800">
                {historyTitle}
              </h2>
              <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-red-500 mb-8 rounded-full"></div>
              <div className="space-y-6 text-stone-600">
                {historyTexts.map((text, idx) => (
                  <p key={idx} className="text-lg leading-relaxed">{text}</p>
                ))}
              </div>
            </div>

            <div className="animate-slide-right">
              <div className="relative">
                <div className="w-full h-96 rounded-2xl flex items-center justify-center bg-stone-200/50 border border-stone-200/60">
                  <div className="text-center">
                    <div className="w-32 h-32 bg-stone-300/60 rounded-full flex items-center justify-center mx-auto mb-6">
                      <svg className="w-16 h-16 text-stone-500" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M17 7h-4V3a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v8H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2h-4V9h4a1 1 0 0 0 0-2Z"/>
                      </svg>
                    </div>
                    <p className="font-serif italic text-lg text-stone-500">
                      [Aquí iría una imagen histórica de la iglesia]
                    </p>
                    <div className="w-16 h-px bg-stone-300 mx-auto mt-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Somos Cuadrangulares - Información Legal */}
      <section className="py-24 px-6">
        <div className="max-w-5xl mx-auto">
          <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium text-center">{legalLabel}</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-2 text-center">
            {legalTitle}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto mb-10 rounded-full"></div>
          
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-stone-200/60">
            <div className="space-y-6 text-stone-700 leading-relaxed text-justify">
              <p>{legalText1}</p>
              <p>{legalText2}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Símbolo Identitario - La Bandera Cuadrangular */}
      <section className="py-24 px-6">
        <div className="max-w-6xl mx-auto">
          <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium text-center">{flagLabel}</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-2 text-center">
            {flagTitle}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto mb-8 rounded-full"></div>
          
          <p className="text-stone-600 text-center leading-relaxed max-w-3xl mx-auto mb-12">
            {flagDescription}
          </p>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Colores y significados */}
            <div className="space-y-6">
              {flagColors.map((c) => (
                <div key={c.nombre} className="flex items-start gap-4">
                  <div className={`w-14 h-14 rounded-xl shadow-md shrink-0 ${c.color}`}></div>
                  <div>
                    <h3 className="text-lg font-serif font-bold text-stone-800">{c.nombre}</h3>
                    <p className="text-stone-600 text-sm leading-relaxed">{c.significado}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Imagen de la bandera */}
            <div className="flex items-center justify-center">
              <div className="w-full max-w-sm overflow-hidden rounded-2xl border border-stone-200/60 shadow-sm">
                <img 
                  src={flagImage} 
                  alt={flagTitle} 
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Misión y Visión */}
      <section className="py-24 px-6 bg-stone-200/40">
        <div className="max-w-6xl mx-auto">
          <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium text-center">{purposeLabel}</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-2 text-center">
            {purposeTitle}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto mb-16 rounded-full"></div>
          
          <div className="grid md:grid-cols-2 gap-12">
            
            {/* Misión */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-stone-200/60 hover:shadow-lg transition-all duration-300 group">
              <div className="w-16 h-16 bg-stone-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-stone-200 transition-colors">
                <span className="text-stone-600 text-2xl">🎯</span>
              </div>
              <h3 className="text-2xl font-serif font-bold text-center mb-3 text-stone-800">
                {missionTitle}
              </h3>
              <div className="w-8 h-px bg-stone-300 mx-auto mb-4"></div>
              <p className="text-stone-600 text-center leading-relaxed">
                {missionText}
              </p>
            </div>

            {/* Visión */}
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-stone-200/60 hover:shadow-lg transition-all duration-300 group">
              <div className="w-16 h-16 bg-stone-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-stone-200 transition-colors">
                <span className="text-stone-600 text-2xl">👁️</span>
              </div>
              <h3 className="text-2xl font-serif font-bold text-center mb-3 text-stone-800">
                {visionTitle}
              </h3>
              <div className="w-8 h-px bg-stone-300 mx-auto mb-4"></div>
              <p className="text-stone-600 text-center leading-relaxed">
                {visionText}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Los 4 Pilares Cuadrangulares */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium text-center">{pillarsLabel}</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-2 text-center">
            {pillarsTitle}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto mb-6 rounded-full"></div>
          <p className="text-xl text-center text-stone-500 mb-16">
            {pillarsSubtitle}
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {pillars.map((p, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-8 text-center border border-stone-200/60 shadow-sm hover:shadow-lg transition-all duration-300 group">
                <div className="w-32 h-32 mx-auto mb-6 overflow-hidden rounded-2xl bg-stone-100 ring-1 ring-stone-200/60 shadow-sm">
                  <img src={p.imagen || imgSalvador} alt={p.titulo.replace('\n', ' ')} className="w-full h-full object-cover" />
                </div>
                <h3 className="text-xl font-serif font-bold text-stone-800 mb-2 whitespace-pre-line">
                  {p.titulo}
                </h3>
                <div className="w-8 h-px bg-stone-300 mx-auto mb-4"></div>
                <p className="text-stone-600 text-sm leading-relaxed">
                  {p.descripcion}
                </p>
                <div className="mt-4 text-xs font-semibold text-purple-700">
                  {p.versiculo}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Liderazgo */}
      <section className="py-24 px-6 bg-stone-200/40">
        <div className="max-w-6xl mx-auto">
          <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium text-center">{leadershipLabel}</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-2 text-center">
            {leadershipTitle}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto mb-16 rounded-full"></div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {leaders.map((l, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-8 text-center shadow-sm border border-stone-200/60 hover:shadow-lg transition-all duration-300 group">
                <div className="w-24 h-24 bg-stone-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-stone-200 transition-colors">
                  <span className="text-stone-600 text-2xl">{l.icono}</span>
                </div>
                <h3 className="text-xl font-serif font-bold text-stone-800 mb-1">
                  {l.nombre}
                </h3>
                <p className="font-semibold mb-4 text-purple-700">{l.cargo}</p>
                <div className="w-8 h-px bg-stone-300 mx-auto mb-4"></div>
                <p className="text-stone-600 text-sm leading-relaxed">
                  {l.descripcion}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="py-24 px-6">
        <div className="max-w-6xl mx-auto">
          <p className="text-stone-500 text-sm uppercase tracking-[0.3em] mb-3 font-medium text-center">{valuesLabel}</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-2 text-center">
            {valuesTitle}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-red-500 mx-auto mb-16 rounded-full"></div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {values.map((v, idx) => (
              <div key={idx} className="text-center group">
                <div className="w-16 h-16 bg-stone-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-stone-200 transition-colors">
                  <span className="text-stone-600 text-xl">{v.icono}</span>
                </div>
                <h3 className="text-xl font-serif font-bold text-stone-800 mb-2">{v.titulo}</h3>
                <div className="w-6 h-px bg-stone-300 mx-auto mb-3"></div>
                <p className="text-stone-600 text-sm leading-relaxed">
                  {v.descripcion}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default NosotrosPage;